<template>
  <div class="md:flex items-stretch">
    <div class="flex flex-col flex-grow overflow-scroll">
      <div class="product flex flex-col items-stretch min-h-screen">
        <product-header :title="product.description" :uom="product.uom" :impa-code="product.part_no"
          :categories="product.categories" />

        <div class="product-details relative xl:flex-1 xl:flex xl:items-stretch xl:justify-between">
          <div class="container w-full py-8 flex flex-col-reverse justify-end md:justify-between md:flex-row">
            <div class="w-full" style="max-width:800px">
              <p>{{ product.explanation }}</p>
              <table class="product-attributes mt-8">
                <product-attribute label="IMPA Code:" :value="product.part_no" />
                <product-attribute label="UOM:" :value="product.uom" />
                <product-attribute label="MTML UOM:" :value="product.mtml_uom" />
                <product-attribute label="Level 1 Category:" :value="product.categories.level_1.title"
                  v-if="product.categories.level_1" />
                <product-attribute label="Level 2 Category:" :value="product.categories.level_2.title"
                  v-if="product.categories.level_2" />
                <product-attribute label="Level 3 Category:" :value="product.categories.level_3.title"
                  v-if="product.categories.level_3" />
              </table>
            </div>
            <div class="md:w-1/3 md:ml-8 flex-shrink-0">
              <div class="flex flex-col justify-center mb-8" v-if="loaded">
                <a @click="addProductToCart(product)" class="text-lg button cursor-pointer"
                  v-if="!$store.state.user.userGroups.includes('trial') && this.loaded">
                  <font-awesome-icon icon="plus" class="mr-2 hover:mr-4" />
                  Add to basket
                </a>
              </div>
              <img :src="product.picture" v-if="product.picture" class="w-full">
              <img src="/images/placeholder.jpg" class="w-full" v-else>
            </div>
          </div>
          <iframe src="/advert/sidebar" frameborder="0" class="p-6 w-64 bg-gray-200"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader.vue'
import ProductAttribute from '../components/ProductAttribute'
import Categories from '../components/Categories'
import { mapActions } from 'vuex'

export default {
  components: {
    ProductHeader,
    Categories,
    ProductAttribute
  },
  data: function () {
    return {
      loaded: false,
      productId: this.$route.params.id,
      product: {
        part_no: "XXXXXX",
        description: "",
        explanation: "",
        mtml_uom: "XXX",
        uom: "XXX",
        categories: {
          level_1:
          {
            id: "",
            title: "XXX",
            code: null
          },
          level_2:
          {
            id: "",
            title: "XXX",
            code: null
          },
          level_3:
          {
            id: "",
            title: "XXX",
            code: null
          }
        },
        picture: "/images/placeholder.jpg",
        dateUpdated: null,
        dateCreated: null
      }
    }
  },
  methods: {
    addProductToCart(product) {
      this.$store.dispatch('cart/addProductToCart', product)
      this.$ga.event({
        eventCategory: 'Basket',
        eventAction: 'add',
        eventValue: product.part_no
      })
    },
  },
  mounted() {
    // Let's make the product pages instant
    if (this.$route.params.product) {
      var categories = this.$route.params.product.categories[2].level3.split(" > ")
      const passedProduct = this.$route.params.product
      this.product.description = passedProduct.description
      this.product.explanation = passedProduct.explanation
      this.product.part_no = passedProduct.part_no
      this.product.uom = passedProduct.uom
      this.product.mtml_uom = passedProduct.mtml_uom
      this.product.picture = passedProduct.thumbnail
      this.product.categories.level_1.title = categories[0]
      this.product.categories.level_2.title = categories[1]
      this.product.categories.level_3.title = categories[2]
      this.loaded = true;
    }
    this.$http.get('/actions/api-proxy-module/default/product?product=' + this.productId)
      .then((response) => {
        this.product = response.data;
        this.loaded = true;
      });
  }
}
</script>

<style>
.product-attributes tr:nth-child(even) {
  @apply bg-gray-100;
}
</style>
